export const SET_RESOLUTION_FILTERS = 'SET_RESOLUTION_FILTERS';

export const RESET_RESOLUTION_FILTERS = 'RESET_RESOLUTION_FILTERS';

export const SET_RESOLUTION_GRID_SORT_CRITERIA = 'SET_RESOLUTION_GRID_SORT_CRITERIA';
